// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2WrRO","bigColWidth":"Table_bigColWidth__3hchx","biggerColWidth":"Table_biggerColWidth__1tSOg","row":"Table_row__2_ljq","col":"Table_col__3qLZc"};